// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries
import React from "react";
// import PropTypes from 'prop-types';
import { css } from "glamor";
import Link from "gatsby-link";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components
import { Elements } from "@bodhi-project/typography";
import { Image, OutLink } from "@bodhi-project/components";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals
import DefaultSection from "../components/DefaultSection";
import Background from "../assets/landing-banner-background.jpg";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions
const { H1 } = Elements;

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Functions
// ----------------------------------------------------------------------------

// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Styles
// ----------------------------------------------------------------------------
const blockStyle = css({
  minHeight: "calc(80vh - 70px)",
  backgroundImage: `url(${Background})`,
  backgroundSize: "cover",
  display: "flex",
  alignItems: "center",
  alignContent: "center",

  "& .ant-btn-primary": {
    fontWeight: 500,
    fontSize: "1.5rem",
    padding: "8px 25px",
    fontStyle: "italic",
    borderRadius: 0,
    backgroundColor: "#555555",
    borderColor: "transparent",
    borderWidth: 0,
    color: "#FFFFFF !important",
    height: "auto",
    transition: "all 200ms cubic-bezier(0.78, 0.14, 0.15, 0.86)",
    "&:not(:last-child)": {
      marginRight: "20px"
    },
    borderBottom: "unset !important",

    "&:hover": {
      backgroundColor: "#909090 !important",
      transform: "scale(1.1)",
      borderBottom: "unset !important"
    }
  }
});
const blockStyleClass = blockStyle.toString();

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
/** AboutIntroduction */
class AboutIntroduction extends React.Component {
  /** standard constructor */
  constructor(props) {
    super(props);
  }

  /** standard renderer */
  render() {
    return (
      <DefaultSection className={blockStyleClass}>
        <H1
          mask="p"
          scale="1.5X"
          style={{
            flexGrow: 3,
            flexBasis: 0,
            textAlign: "center"
          }}
        >
          <strong style={{ fontSize: "175%", color: "#c32148" }}>
            Digital Media Reserve
          </strong>
          <br />
          <br />
          <strong>
            <i style={{ color: "#555555" }}>
              Unleashing DRM protection and fulfillment of your eBooks
            </i>
          </strong>
          <br />
          <br />
        </H1>
      </DefaultSection>
    );
  }
}

// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Exports
// ----------------------------------------------------------------------------
export default AboutIntroduction;



// WEBPACK FOOTER //
// ./src/blocks/LandingBanner.jsx